import React, { Component } from "react";
import { Row, Col, Button, Modal, Container, Form } from "react-bootstrap";
import Switch from "react-switch";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

class AddPaymentMode extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: {
        payMode: "",
        payModeDescp: "",
        isActive: true
      }
    };
  }

  handleChange = checked => {
    this.setState({ value: { ...this.state.value, isActive: checked } });
  };

  onChange = event => {
    let name = event.target.name;
    let value = event.target.value;
    if (name == "payMode") {
      this.setState({
        value: { ...this.state.value, payMode: value }
      });
    } else if (name == "payModeDescp") {
      this.setState({
        value: { ...this.state.value, payModeDescp: value }
      });
    }
  };

  submit = () => {
    let data = this.state.value;
    // console.log(data);

    if (data.payMode !== "" && data.payModeDescp !== "") {
      this.props.AddPaymentMode(this.state.value);
      this.setState({
        value: {
          payMode: "",
          payModeDescp: "",
          isActive: true
        }
      });
      this.props.closeAddModel();
      this.props.resetPage();
    } else {
      toast.error("Please fill all required fields", {
        autoClose: 2000,
        position: toast.POSITION.TOP_CENTER
      });
    }
  };

  closeModel = () => {
    this.setState({
      value: {
        payMode: "",
        payModeDescp: "",
        isActive: true
      }
    });
    this.props.closeAddModel();
  };
  render() {
    return (
      <div>
        <Modal
          show={this.props.showpaymodeAddModel}
          onHide={this.closeModel}
          animation={false}
          size="md"
          backdrop="static"
        >
          <Modal.Header
            style={{ fontSize: "35px", backgroundColor: "#f0f3f5" }}
            closeButton
          >
            <Modal.Title>Payment Mode</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Container>
              <Row>
                <Col lg={12}>
                  <Form>
                    <div style={{ maxWidth: 280, margin: "auto" }}>
                      <div>
                        <Form.Group controlId="payMode">
                          <Form.Label> Name </Form.Label>
                          <Form.Control
                            type="text"
                            // placeholder="PaymentMode"
                            autoComplete="off"
                            name="payMode"
                            onChange={this.onChange}
                            value={this.state.value.payMode}
                          />
                        </Form.Group>
                      </div>

                      <div>
                        <Form.Group controlId="payModeDescp">
                          <Form.Label>Description</Form.Label>
                          <Form.Control
                            as="textarea"
                            // placeholder="PaymentMode Description"
                            name="payModeDescp"
                            autoComplete="off"
                            onChange={this.onChange}
                            value={this.state.value.payModeDescp}
                          />
                        </Form.Group>
                      </div>

                      <div>
                        <label style={{ display: "flex", marginTop: "8px" }}>
                          <div style={{ marginRight: "30px" }}>
                            <span>Active</span>
                          </div>
                          <div style={{ marginTop: "-5px" }}>
                            <Switch
                              onChange={this.handleChange}
                              onColor="#20a8d8"
                              checked={this.state.value.isActive}
                            />
                          </div>
                        </label>
                      </div>
                    </div>
                  </Form>
                </Col>
              </Row>
            </Container>
          </Modal.Body>
          <Modal.Footer style={{ backgroundColor: "#f0f3f5" }}>
            <Button type="submit" onClick={this.submit}>
              Submit
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}

export default AddPaymentMode;
